const styles = theme => ({
  container: {
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0
  },
  topBar: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    background: theme.palette.primary.main,
    color: "#fff",
    textTransform: "uppercase",
    padding: `${theme.spacing(2)}px 0`,
    textAlign: "center",
    "&> button": {
      paddingTop: 0,
      paddingBottom: 0
    }
  },
  iconButton: {
    zIndex: 1,
    position: "relative",
    borderRadius: "50%",
    height: "36px",
    width: "36px",
    marginLeft: theme.spacing(2)
  },
  backIcon: {
    position: "absolute",
    left: 10,
    height: "18px"
  },
  root: {
    width: "100%",
    maxWidth: 600,
    boxShadow: "none",
    margin: "0 auto",
    background: "transparent"
  },
  media: {
    position: "relative",
    height: 0,
    paddingTop: "100%",
    maxWidth: 500,
    margin: "0 auto"
  },
  settings: {
    position: "absolute",
    top: 0,
    right: 0,
    color: "#fff"
  },
  header: {
    paddingBottom: theme.spacing(0.5),
    "&> div:nth-of-type(3)": {
      margin: 0,
      color: theme.palette.primary.light
    }
  },
  cardHeaderAction: {
    alignSelf: "auto"
  },
  content: {
    paddingTop: 0
  },
  body: {
    paddingTop: 0,
    paddingLeft: theme.spacing(7)
  },
  posted: {
    paddingLeft: theme.spacing(7)
  },
  postedList: {
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    "&> li": {
      padding: `0 15px 0 0`,
      width: "auto"
    }
  },
  image: {
    margin: "0 auto",
    maxWidth: 600
  },
  video: {
    margin: "0 auto",
    maxWidth: 600
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/App/Post/styles.js